common.View.create('website::layouts.main.Slider', {

    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {
        this.element.find('.owl-carousel').owlCarousel({
            loop: this.element.find('.owl-carousel').children().length > 1,
            nav: this.element.find('.owl-carousel').data('show-navigation'),
            dots: this.element.find('.owl-carousel').data('show-dots') && this.element.find('.owl-carousel').children().length > 1,
            items: 1,
            margin: 5,
            stageClass: 'h-full owl-stage',
            stageOuterClass: 'h-full owl-stage-outer',
            itemClass: 'h-full owl-item',
        });
    }
});
